module.exports = __webpack_public_path__ + "img/slide1.29e38360.webp";